import Request from '@/utils/request';

class User extends Request {
  // 获取用户信息
  fetchUserInfo(data) {
    return this.post('/user/getInfo', data);
  }

  // 获取手机验证码
  fetctGetPhoneCode(data) {
    return this.post('/main/getPhoneCode', data);
  }

  // 登录
  fetchMainLogin(data) {
    return this.post('/main/login', data);
  }

  // 上传头像
  fetchUploadAvatar(data) {
    return this.post('/upload/avatar', data);
  }

  // 上传头像
  loadAboutUs(data) {
    return this.post('/article/getAboutUs', data);
  }

  // 获取文章列表
  loadArticleList(data) {
    return this.post('/article/list', data);
  }

  // 获取文章详情
  loadArticleDetail(data) {
    return this.post('/article/get', data);
  }

  // 获取代金券列表
  loadCouponList(data) {
    return this.post('/coupon/list', data);
  }

  // 新增意见反馈
  createFeedback(data) {
    return this.post('/feedback/add', data);
  }

  // 获取国家省市信息
  loadAreaList(data) {
    return this.post('/area/list', data);
  }

  // 新增/修改地址
  createAddress(data) {
    return this.post('/address/update', data);
  }

  // 获取地址
  loadAddressList(data) {
    return this.post('/address/list', data);
  }

  // 删除地址
  deleteAddress(data) {
    return this.post('/address/delete', data);
  }

  // 更新用户信息
  updateUser(data) {
    return this.post('/user/update', data);
  }

  // 获取默认地址
  loadDefaultAddress(data) {
    return this.post('/address/getDefault', data);
  }

  // 准备订单
  loadPrepareOrder(data) {
    return this.post('/order/prepare', data);
  }

  // 创建订单
  createOrder(data) {
    return this.post('/order/create', data);
  }

  // 获取订单列表
  loadOrderList(data) {
    return this.post('/order/list', data);
  }

  // 立即购买
  buyNow(data) {
    return this.post('/order/buyNow', data);
  }

  // 取消订单
  orderCancel(data) {
    return this.post('/order/cancel', data);
  }

  // 确认收货
  orderFinish(data) {
    return this.post('/order/finish', data);
  }

  // 订单统计
  orderStat(data) {
    return this.post('/order/stat', data);
  }

  // 准备付款
  readyToPay(data) {
    return this.post('/order/readyToPay', data);
  }

  // 订单付款
  confrimPay(data) {
    return this.post('/order/pay', data);
  }

  // 申请退款
  requestRefound(data) {
    return this.post('/order/requestRefound', data);
  }

  // 获取用户账户金额
  getMoney(data) {
    return this.post('/user/getMoney', data);
  }

  // 获取用户账户金额
  requestDraw(data) {
    return this.post('/user/getMoney', data);
  }

  // 获取注册协议
  getRegTerm(data) {
    return this.post('/article/getRegTerm', data);
  }
}

export default new User();
